import type { FC, ReactNode } from 'react'

// Shared label, hint and error wrapper for the site's forms. Pair it with INPUT_CLASSES on the control.

export const INPUT_CLASSES = 'block w-full rounded-lg border border-input bg-background/60 px-4 text-base text-foreground placeholder:text-muted-foreground/60 transition-colors hover:border-white/30 focus:border-race focus:outline-none focus:ring-2 focus:ring-race/40 aria-[invalid=true]:border-destructive'

interface FormFieldProps {
    id: string
    label: string
    hint?: string
    error?: string
    className?: string
    children: ReactNode
}

const FormField: FC<FormFieldProps> = ({ id, label, hint, error, className, children }): ReactNode => {
    return (
        <div className={className}>
            <label htmlFor={id} className='flex items-baseline justify-between gap-3 text-sm font-medium text-foreground'>
                {label}

                {hint && (
                    <span className='text-xs font-normal text-muted-foreground'>
                        {hint}
                    </span>
                )}
            </label>

            <div className='mt-2'>
                {children}
            </div>

            {error && (
                <p id={`${id}-error`} className='mt-2 text-sm text-destructive'>
                    {error}
                </p>
            )}
        </div>
    )
}

export default FormField
